// extracted by mini-css-extract-plugin
export var divider = "_tk-0";
export var systemMessage = "_tk-1";